// removed by extract-text-webpack-plugin
module.exports = {"projectConfirmDeleteNode":"TKmp7Mjk4p1txXHD","title":"_2fpn3jVadJ9ckQ1o","controls":"_1Rn180XqAS8mzsIj","cancel":"_2VywIZlwMYsqC8h6","remove":"_3VHf8GsbpYLroz4H"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Popups/ProjectConfirmRemoveNode/ProjectConfirmDeleteNode.pcss
// module id = 493
// module chunks = 1